import ExcelImport from "../singleton/excel-import";
import ExcelExportTemplate from "../singleton/excel-export-template";
import ExcelExport from "../singleton/excel-export";

export default {

    Export: {

        global: ExcelExport.global.bind(ExcelExport),

        tpl: ExcelExport.tpl.bind(ExcelExport),

        getFields: ExcelExport.getFields.bind(ExcelExport),

        Template: {

            getAll: ExcelExportTemplate.getAll.bind(ExcelExportTemplate),

            get: ExcelExportTemplate.get.bind(ExcelExportTemplate),

            delete: ExcelExportTemplate.delete.bind(ExcelExportTemplate),

            setOrder: ExcelExportTemplate.setOrder.bind(ExcelExportTemplate)

        }

    },

    Import: {

        getSheets: ExcelImport.getSheets.bind(ExcelImport),

        parse: ExcelImport.parse.bind(ExcelImport),

        parseMultiple: ExcelImport.parseMultiple.bind(ExcelImport)

    }

}